import { useZocksQuota } from '../components/ScopedBlock/hooks'

export const useCustomWorkflowsEnabled = (): { enabled: boolean; isLoading: boolean } => {
  const { hasQuota, quotaSuccess, isFetching } = useZocksQuota()
  return { enabled: hasQuota('workflow.customWorkflowsEnabled.value'), isLoading: !quotaSuccess && isFetching }
}
